import { apiClient, publicClient } from "./axios-client";
import type { AxiosRequestConfig } from "axios";

// Protected methods (with auth)
export const protectedApi = {
  get: async <T>(endpoint: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await apiClient.get<T, any>(endpoint, config);
    return response;
  },

  post: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await apiClient.post<T, any>(endpoint, data, config);
    return response;
  },

  put: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await apiClient.put<T, any>(endpoint, data, config);
    return response;
  },

  patch: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await apiClient.patch<T, any>(endpoint, data, config);
    return response;
  },

  delete: async <T>(
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await apiClient.delete<T, any>(endpoint, config);
    return response;
  },

  head: async (
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<void> => {
    await apiClient.head(endpoint, config);
  },

  options: async (
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<void> => {
    await apiClient.options(endpoint, config);
  },
};

// Public methods (without auth)
export const publicApi = {
  get: async <T>(endpoint: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await publicClient.get<T, any>(endpoint, config);
    return response;
  },

  post: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await publicClient.post<T, any>(endpoint, data, config);
    return response;
  },

  put: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await publicClient.put<T, any>(endpoint, data, config);
    return response;
  },

  patch: async <T, D = unknown>(
    endpoint: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await publicClient.patch<T, any>(endpoint, data, config);
    return response;
  },

  delete: async <T>(
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const response = await publicClient.delete<T, any>(endpoint, config);
    return response;
  },

  head: async (
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<void> => {
    await publicClient.head(endpoint, config);
  },

  options: async (
    endpoint: string,
    config?: AxiosRequestConfig,
  ): Promise<void> => {
    await publicClient.options(endpoint, config);
  },
};
